// FORMAT PRODUCT ITEM FOR CART
export function formatCartProduct(item) {
  const shippingMethodsType = ["installation", "technical_visit", "standard_delivery"];

  let shippingMethod = "";
  if (item.type) {
    if (shippingMethodsType.includes(item.type)) {
      shippingMethod = "shipping_methods";
    } else {
      shippingMethod = item.type;
    }
  } else {
    shippingMethod = "";
  }

  return {
    productId: item.product_id ?? "",
    itemId: item.item_id ?? "",
    isMainProduct: item.main_product ?? false,
    sku: item.sku ?? "",
    baRefConstructeur: item.ba_refconstructeur ?? "",
    name: item.name ?? "",
    shortDescription: item.short_description,
    quantity: item.qty ?? 1,
    price: item.price_incl_tax ?? "",
    basePrice: item.original_price_incl_tax ?? "",
    totalPrice: item.row_total_incl_tax ?? "",
    baseTotalPrice: item.original_row_total_incl_tax ?? "",
    type: shippingMethod,
    originalType: item.type ?? "",
    thumbnail: item.thumbnail ?? "",
    productUrlKey: item.url_key ?? null,
    relatedProducts: item.related_products ?? [],
    isAccessoryProduct: item.is_accessory_product ?? false,
  };
}
